<p-toast></p-toast>

<ng-container *transloco="let t">
  <p-dialog
    [visible]="open()"
    (visibleChange)="onVisibleChange($event)"
    [modal]="true"
    [draggable]="false"
    [dismissableMask]="!sending()"
    [closeOnEscape]="!sending()"
    [closable]="!sending()"
    [style]="{ width: '460px', maxWidth: '94vw' }"
    [header]="t('chat.contact.title')"
    appendTo="body"
    styleClass="contact-candidate-dialog">
    @if (target(); as candidate) {
      <div class="contact-form">
        <div class="contact-form__to ow-mono">{{ t('chat.contact.to', { name: candidate.name }) }}</div>

        <div class="contact-form__field">
          <label for="contact-subject">{{ t('chat.contact.subjectLabel') }}</label>
          <input
            pInputText
            id="contact-subject"
            class="w-full"
            [ngModel]="subject()"
            (ngModelChange)="subject.set($event)"
            [placeholder]="t('chat.contact.subjectPlaceholder')"
            [disabled]="sending()" />
        </div>

        <div class="contact-form__field">
          <label for="contact-message">{{ t('chat.contact.messageLabel') }}</label>
          <textarea
            pTextarea
            id="contact-message"
            class="w-full"
            rows="5"
            [ngModel]="message()"
            (ngModelChange)="message.set($event)"
            [placeholder]="t('chat.contact.messagePlaceholder')"
            [disabled]="sending()"></textarea>
        </div>
      </div>

      <ng-template pTemplate="footer">
        <p-button
          [label]="t('chat.contact.cancel')"
          severity="secondary"
          [text]="true"
          [disabled]="sending()"
          (onClick)="onVisibleChange(false)">
        </p-button>
        <p-button
          [label]="t('chat.contact.send')"
          icon="pi pi-send"
          [loading]="sending()"
          [disabled]="!canSend()"
          (onClick)="onSend()">
        </p-button>
      </ng-template>
    }
  </p-dialog>
</ng-container>
